import { render, staticRenderFns } from "./D3Chart.vue?vue&type=template&id=2a957c4c&scoped=true&"
import script from "./D3Chart.vue?vue&type=script&lang=js&"
export * from "./D3Chart.vue?vue&type=script&lang=js&"
import style0 from "./D3Chart.vue?vue&type=style&index=0&id=2a957c4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a957c4c",
  null
  
)

export default component.exports